import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Unfiltered Great Plains (CTC) job list used to populate selectors. */
export function useCtcJobOptions(enabled = true) {
  return useQuery({
    queryKey: queryKeys.ctc.list([]),
    queryFn: ({ signal }) =>
      ctcApiClient.listCTCWithFilters({}, toCancelToken(signal)),
    enabled,
    staleTime: 5 * 60_000,
    meta: { errorContext: 'CTC jobs' },
  });
}
